import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, Core2Config, Pagination, PagingResponseModel} from '../../shared';
import {ConsolidatedArapLoginSubjectLinkContainerModel} from '../../../../../../models/aggregates/erp/entity';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})

export class ConsolidatedArapLoginSubjectLinkService extends BaseApiPublicLoginTemplateService<ConsolidatedArapLoginSubjectLinkContainerModel, ConsolidatedArapLoginSubjectLinkContainerModel, ConsolidatedArapLoginSubjectLinkContainerModel> {
  
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'consolidated-arap-login-subject-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
  static readonly ENTITY_LOGIN_SUBJECT_SUB_PATH = '/';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'consolidated-arap-login-subject-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'consolidated-arap-login-subject-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'consolidated-arap-login-subject-links' + ConsolidatedArapLoginSubjectLinkService.ENTITY_LOGIN_SUBJECT_SUB_PATH + BaseApiPublicLoginTemplateService.LOGIN_ENTITY_EP;
  }

}
